// Main Banner
var bgImgUrlLarge = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER-Prints-Oversized-Blazer-Handloom-Chili-8_2048x.jpg?v=1608253721";
//console.log("Large URL: " + bgImgUrlLarge);
var bgImgUrlTablet = "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1024x.gif";
//console.log("Medium URL: " + bgImgUrlTablet);
var bgImgUrlMobile = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER-Prints-Oversized-Blazer-Handloom-Chili-4_82fc8438-f199-4994-9189-de6014a6104b_640x.jpg?v=1608253703";

// Journal Image 1
var j1BgImgUrlLarge = "//cdn.shopify.com/s/files/1/0256/1325/files/fc51a784-cd1e-4627-a4e6-73ffb07d5042_600x.gif?v=1595998035";
var j1BgImgUrlTablet = "//cdn.shopify.com/s/files/1/0256/1325/files/fc51a784-cd1e-4627-a4e6-73ffb07d5042_600x.gif?v=1595998035";
var j1BgImgUrlMobile = "//cdn.shopify.com/s/files/1/0256/1325/files/fc51a784-cd1e-4627-a4e6-73ffb07d5042_600x.gif?v=1595998035";

// Journal Image 2
var j2BgImgUrlLarge = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER_POSTER_600x.jpg?v=1598453833";
var j2BgImgUrlTablet = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER_POSTER_600x.jpg?v=1598453833";
var j2BgImgUrlMobile = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER_POSTER_600x.jpg?v=1598453833";

// Journal Image 3
var j3BgImgUrlLarge = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER-Making-of-Matter-Artisans-Hand-6_3_600x.jpg?v=1592211789";
var j3BgImgUrlTablet = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER-Making-of-Matter-Artisans-Hand-6_3_600x.jpg?v=1592211789";
var j3BgImgUrlMobile = "//cdn.shopify.com/s/files/1/0256/1325/files/MATTER-Making-of-Matter-Artisans-Hand-6_3_600x.jpg?v=1592211789";


// Main Banner

// console.log("Small URL: " + bgImgUrlMobile);
var wWidth = window.innerWidth;  
// console.log("Window Width: " + wWidth);    

if(wWidth < 481) {
  document.getElementById("mainHeader").style.backgroundImage = 'url(' + bgImgUrlMobile + ')';    
  document.getElementById("j1").style.backgroundImage = 'url(' + j1BgImgUrlMobile + ')';    
  document.getElementById("j2").style.backgroundImage = 'url(' + j2BgImgUrlMobile + ')';    
  document.getElementById("j3").style.backgroundImage = 'url(' + j3BgImgUrlMobile + ')';    
}
// else if (wWidth < 768) {
//   document.getElementById("mainHeader").style.backgroundImage = 'url(' + bgImgUrlTablet + ')';    
//   document.getElementById("j1").style.backgroundImage = 'url(' + j1BgImgUrlTablet + ')';    
//   document.getElementById("j2").style.backgroundImage = 'url(' + j2BgImgUrlTablet + ')';    
//   document.getElementById("j3").style.backgroundImage = 'url(' + j3BgImgUrlTablet + ')';      
// }
else {
  document.getElementById("mainHeader").style.backgroundImage = 'url(' + bgImgUrlLarge + ')';
  document.getElementById("j1").style.backgroundImage = 'url(' + j1BgImgUrlLarge + ')';  
  document.getElementById("j2").style.backgroundImage = 'url(' + j2BgImgUrlLarge + ')';  
  document.getElementById("j3").style.backgroundImage = 'url(' + j3BgImgUrlLarge + ')';  
}  


